// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../../shared/components/report-criteria-footer';
import {exportToCSV} from '../../../../reports/shared/services/export-to-csv';
import {isNotEmpty} from '../../../../claim/shared/services/claim-shared-helper';

function handleInputChange(event) {

    this.actions.updateCriteria(event.target.value);

}

function handleCriteriaReset() {

    this.actions.resetCriteria();
    this.actions.resetReport();
    this.actions.updateShowNoResultsFound(false);

}

function handleReportDownload() {

    const fileName = 'pip-history';

    return exportToCSV(fileName, this.gridApi);

}

function handleRunReport() {

    this.actions.toggleReportIsScrollable();
    this.actions.resetReport();
    this.actions.readPipHistory(this.criteria);

}

const ReportCriteria = props =>
    <div className='report-criteria'>
        <div className='criteria-container'>
            <LabeledCriteria
                className='pin-criteria'
                isRequired={true}
                label='PIN'
                maxLength='17'
                onInputChange={props::handleInputChange}
                placeholder='PIN'
                type='text'
                value={props.criteria}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={isNotEmpty(props.criteria)}
            isRequired={true}
            onCriteriaReset={props::handleCriteriaReset}
            onDownloadToExcel={props::handleReportDownload}
            onRunReport={props::handleRunReport}
            showExport={true}
            showReport={true}
        />
    </div>;

ReportCriteria.displayName = 'ReportCriteria';
ReportCriteria.propTypes = {
    actions: PropTypes.object.isRequired,
    canExport: PropTypes.bool.isRequired,
    criteria: PropTypes.string.isRequired,
    gridApi: PropTypes.object.isRequired
};

export default ReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/pip-history/components/report-criteria/report-criteria.js